import React, { useState } from 'react'
import styled from 'styled-components'
import firebase from 'firebase/app'
import { PrimaryButton } from '../components/UI/PrimaryButton'
import { colors } from '../styles/colors'

const Container = styled.div`
    padding: 0 2rem; 
    form {
        max-width: 500px;
        padding: 5rem 12.5rem;
        background: ${colors.dark_blue};
        box-shadow: -16px 16px 6px rgba(0, 0, 0, 0.4);

        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 5rem auto;

        @media (min-width: 321px) and (max-width: 767.98px) {
            padding: 10rem 5rem;
        }
        @media (max-width: 320px) {
            padding: 10rem 2rem;
        }
    }

    .title {
        font-family: 'SF UI Text',sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
        color: ${colors.white};
        text-align: center;
        margin-bottom: 3.75rem;
    }

    input {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};

        padding-left: 2.5rem; 

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        outline: none;

        :not(:last-child) {
            margin-bottom: 3.75rem;
        }

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin-bottom: 3.75rem;
        }
    }
`

export const Login = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const formHandler = (e) => {
        e.preventDefault();
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(user => {
                console.log(user);
                alert('welcome!')
            })
            .catch(err => {
                console.log(err);
            })
    }

    const handleEmailChange = e => {
        setEmail(e.target.value)
    }
    const handlePasswordChange = e => {
        setPassword(e.target.value)
    }

    return (
        <Container>
            <form onSubmit={e => formHandler(e)}>
                <p className="title">Вход</p>
                <input type="email" name="email" value={email} placeholder='email' onChange={e => handleEmailChange(e)} />
                <input type="password" name="password" value={password} placeholder='password' onChange={e => handlePasswordChange(e)} />
                <PrimaryButton onClick={ e => formHandler(e) } lighten >Войти</PrimaryButton>
            </form>
        </Container>
    )
}